import { render, staticRenderFns } from "./eliminate.vue?vue&type=template&id=53ad6db6&scoped=true&"
import script from "./eliminate.vue?vue&type=script&lang=js&"
export * from "./eliminate.vue?vue&type=script&lang=js&"
import style0 from "./eliminate.vue?vue&type=style&index=0&id=53ad6db6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad6db6",
  null
  
)

export default component.exports